<template>
  <div>
    <index-card fluid>
      <template slot="header">
        <v-row>
          <v-col class="white--text d-flex justify-space-between headline">
            <div class="d-flex align-center">
              <v-btn icon color="blue-grey darken-1" :to="{name: 'Home'}"><v-icon color="white">mdi-arrow-left</v-icon></v-btn>
              <v-btn class="ml-2" small color="white black--text" @click="dialog_new_bonus_payment = true"><v-icon left>mdi-gift-outline</v-icon>Pagar com bônus</v-btn>
            </div>
            <span>Bônus do cliente</span>
            <div class="d-flex">
              <BtnCreateDataExport 
                class="mx-3"
                :api_model="route_name" 
                :action="route_name"
                :filters="export_filters"
              ></BtnCreateDataExport>
              <v-icon color="white" @click="reloadData" style="cursor: pointer">mdi-refresh</v-icon>
            </div>
          </v-col>
        </v-row>
      </template>
      <template slot="data_table">
        <v-card>
          <v-card-text class="py-0 px-0">
            <v-tabs icons-and-text centered grow color="none">
              <v-tabs-slider color="red"></v-tabs-slider>
              <v-tab :to="{name: 'AvailableBonus'}">
                Bônus disponível
                <v-icon :large="$route.name == 'AvailableBonus'">mdi-account-cash</v-icon>
              </v-tab>
              <v-tab :to="{name: 'BonusPayments'}">
                Pagamentos com bônus
                <v-icon :large="$route.name == 'BonusPayments'">mdi-currency-usd</v-icon>
              </v-tab>
            </v-tabs>
            <router-view ref="activeChild" @filters="handleExportFilters"></router-view>
          </v-card-text>
    
        </v-card>
      </template>
    </index-card>

    <NewPayment
      v-if="dialog_new_bonus_payment"
      kind="bonus"
      @done="reloadData"
      @close="dialog_new_bonus_payment = false"
    ></NewPayment>
  </div>
</template>

<script>
export default {
  name: "IndexClientBonus",
  components: {
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    BtnCreateDataExport: () => import("@/components/data_export/BtnCreateDataExport.vue"),
    NewPayment: () => import('@/_backoffice/_financial/components/order_payment/NewPayment.vue'),
  },
  data() {
    return {
      dialog_new_bonus_payment: false,
      search: "",
      local_filter: {},
      export_filters: {}
    };
  },
  computed:{
    route_name(){
      return this.$route.name
    }
  },
  methods: {
    reloadData(){
      if(this.$refs.activeChild && this.$refs.activeChild.getData){
        this.$refs.activeChild.getData()
      }
    },
    handleExportFilters(filter){
      this.export_filters = {...filter}
    },
  },
  watch: {
  },
};
</script>